import { ANALYTICS_EVENTS } from 'sling-calendar-sdk/constants';

import config from '../../config';

export default class SlingAnalytics {
  constructor(Authentication, SlingApi) {
    'ngInject';

    Object.assign(this, { Authentication, SlingApi });

    this.analyticsEvents = { ...ANALYTICS_EVENTS };
  }

  track(eventName, eventValue = null) {
    const { userId, orgId, email, toastRestaurantGuids } = this.getUserAndOrgData();

    this.SlingApi.analyticsTrack(config.ANALYTICS_END_POINT, {
      type: eventName,
      value: eventValue,
      orgId,
      user: {
        id: userId,
        email,
      },
      toastRestaurantGuids,
    });
  }

  getUserAndOrgData() {
    if (this.Authentication.user) {
      const { id, email, org } = this.Authentication.user;
      return { userId: id, email, orgId: org.id, toastRestaurantGuids: org.toastRestaurantGuids };
    }
    return { userId: null, email: null, orgId: null, toastRestaurantGuids: [] };
  }
}
